import { Phone, Mail } from "lucide-react";
import { usePageMeta } from "../hooks/usePageMeta";
import { SITE } from "../data/site";

const SECTIONS = [
  {
    title: "What we collect",
    body: "When you request a quote, we collect the details you give us: your name, phone number, email address, the property location, the service you need, your preferred contact method, timeframe, a short description of the situation, and any photos you choose to upload. We also note how you heard about us.",
  },
  {
    title: "How we use it",
    body: "We use these details for one purpose only: to respond to your request, prepare an accurate quote, and carry out the work if you choose to hire us. We do not sell, rent, or share your information with marketers, and we do not add you to mailing lists.",
  },
  {
    title: "Photos you upload",
    body: "Photos help us understand the scope of a job before we visit. They are stored securely, visible only to the MacWay team, and used solely to prepare your quote.",
  },
  {
    title: "How long we keep it",
    body: "Quote requests are kept while your inquiry is active and for a reasonable period afterward in case you follow up. If you'd like your details deleted at any time, just ask — by phone or email — and we'll remove them.",
  },
  {
    title: "Questions",
    body: `If you have any questions about how your information is handled, reach us at ${SITE.phone} or ${SITE.email}.`,
  },
];

export default function PrivacyPage() {
  usePageMeta(
    "Privacy Policy | MacWay Estate Services",
    "How MacWay Estate Services handles the details you share when requesting a quote."
  );

  return (
    <main data-testid="privacy-page">
      <section className="bg-forest text-ivory py-20 md:py-24">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
          <p className="eyebrow-label">Your privacy</p>
          <h1 className="mt-4 text-5xl sm:text-6xl font-semibold tracking-tight" data-testid="privacy-headline">
            Privacy Policy
          </h1>
          <p className="mt-5 text-lg text-ivory/80 leading-relaxed">
            Plain and simple — the way we'd want it explained to us.
          </p>
        </div>
      </section>

      <section className="py-16 md:py-20 bg-ivory">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 space-y-10">
          {SECTIONS.map((s) => (
            <div key={s.title} className="bg-white border border-linen p-8">
              <h2 className="text-2xl font-medium text-ink">{s.title}</h2>
              <p className="mt-3 text-base text-ink/70 leading-relaxed">{s.body}</p>
            </div>
          ))}
          <div className="flex flex-col sm:flex-row items-center gap-4 pt-2">
            <a href={SITE.phoneHref} className="btn-outline-dark" data-testid="privacy-call-link">
              <Phone className="w-4 h-4" /> {SITE.phone}
            </a>
            <a href={SITE.emailHref} className="btn-outline-dark" data-testid="privacy-email-link">
              <Mail className="w-4 h-4" /> {SITE.email}
            </a>
          </div>
        </div>
      </section>
    </main>
  );
}
